import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { EmptyText } from "@/components/EmptyText";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_XS } from "@/core/media";
import { Flex, Group, Tooltip } from "@/eworkitComponents";

import { ICompanySectionProps } from "../types";
import { CompanyVatNumberEdit } from "./CompanyVatNumberEdit";

interface ICompanyVatNumberSectionProps extends ICompanySectionProps, IEditableSectionRenderProps {}

export const CompanyVatNumberSection: FC<ICompanyVatNumberSectionProps> = props => {
  const { t } = useTranslation("session");

  const isVerySmallScreen = useMedia(MEDIA_SIZE_XS);
  const polandVatLable =
    props.record.countryCode == "PL"
      ? t("COMPANY.CREATE.POLAND_VAT_NUMBER") // If countryCode PL exists, show this label
      : t("COMPANY.CREATE.VAT_NUMBER"); // Otherwise, show a different label

  const polandVatToolTip =
    props.record.countryCode == "PL"
      ? t("COMPANY.MY_COMPANY.DATA.VAT_NUMBER_TOOLTIP_PL")
      : t("COMPANY.MY_COMPANY.DATA.VAT_NUMBER_TOOLTIP");

  return props.editableProps.editMode && !props.record.vatNo ? (
    <CompanyVatNumberEdit
      editableProps={props.editableProps}
      source={props.record}
      initialValues={{ countryCode: props.record.countryCode, vatNo: props.record.vatNo }}
      onUpdate={props.onUpdate}
      onCancel={props.editableProps.handleCancelClick}
    />
  ) : (
    <Flex direction={isVerySmallScreen ? "column" : "row"} innerMargin="md">
      <Group label={polandVatLable} direction="column">
        <Flex direction="row" innerMargin="xs" align="center">
          <Text size="md" color="black">
            {props.record.vatNo ? `${props.record.countryCode} ${props.record.vatNo}` : <EmptyText />}
          </Text>
          <Tooltip content={polandVatToolTip} placement="top">
            <Flex align="center" justify="center">
              <Icon icon="info" color="grey3" size="md" />
            </Flex>
          </Tooltip>
        </Flex>
      </Group>
    </Flex>
  );
};
